<div class="row">
    <div class="col-xl-3 col-md-6">
        <div class="card border-left card-1 h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                        <p class="font-size font-weight-bold text-primary text-uppercase mb-1">
                            Total échantillions</p>
                        <div class="h5 mb-0 font-weight-bold text-dark">{{ totalSamples }}</div>
                    </div>
                    <div class="col-auto">
                        <i class="fa-solid fa-flask fa-2x icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card border-left card-2 h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                        <p class="font-size font-weight-bold text-uppercase mb-1 ">
                            Total des Ordres de travail</p>
                        <div class="h5 mb-0 font-weight-bold text-dark">{{totalOt}}</div>
                    </div>
                    <div class="col-auto">
                        <i class="fa-solid fa-vial fa-2x icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card border-left card-3 h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                        <p class="font-size font-weight-bold text-uppercase mb-1 ">
                            Total Clients</p>
                        <div class="h5 mb-0 font-weight-bold text-dark">{{ totalClients }}</div>
                    </div>
                    <div class="col-auto">
                        <i class="fa-solid fa-person fa-2x icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card border-left card-4 h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                        <p class="font-size font-weight-bold text-uppercase mb-1 ">
                            Rapports Générés</p>
                        <div class="h5 mb-0 font-weight-bold text-dark">{{totalRapport}}</div>
                    </div>
                    <div class="col-auto">
                        <i class="fa-solid fa-print fa-2x icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

